export const BACK_SPACE = 8;
export const TAB = 9;
export const ENTER = 13;
export const RETURN = 14;
export const ESC = 27;
export const SPACE = 32;
export const LEFT = 37;
export const UP = 38;
export const RIGHT = 39;
export const DOWN = 40;
export const DELETE = 46;
